import { lifecycle } from 'recompose';

const NO_PAGE_HEADER_CLASS = 's-no-page-header';

const withoutPageHeader = lifecycle({
  componentDidMount() {
    document.documentElement.classList.add(NO_PAGE_HEADER_CLASS);
  },
  componentWillUnmount() {
    document.documentElement.classList.remove(NO_PAGE_HEADER_CLASS);
  },
});

export default withoutPageHeader;
